var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"dropdown-divider"}),_c('h6',{staticClass:"dropdown-header"},[_vm._v(_vm._s(_vm.$t('UI_NAV_CUSTOM_IMPORT')))]),_c('button',{staticClass:"dropdown-item",on:{"click":_vm.runScript}},[_vm._v("\n    "+_vm._s(_vm.$t('UI_NAV_RUN_SCRIPT'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }